app.controller('teacherSetupGroupsCtrl', [
    '$scope', '$rootScope', '$http', '$state', 'mdContentService', function ($scope, $rootScope, $http, $state, mdContentService) {
    	var vm = this;

    	vm.loaded = false;
    	vm.games = [];

    	$http.get('/api/gameday/games').then(function(response) {
    		vm.games = response.data.games;
    		vm.loaded = true;

            mdContentService.triggerSyntheticScrollEvent();
    	});

    	vm.add = function() {
    		$http.post('/api/gameday/addgame').then(function(response) {
    			$state.reload();
    		})
    	}

		vm.edit = function(id) {
			$state.go('teacher.groupdetails', { id: id });	
		}

    	vm.delete = function(id) {
    		$http.delete('/api/gameday/game/' + id).then(function(response) {
    			$state.reload();
    		});
    	}

        vm.next = function() {
            $state.go('teacher.groups');
        }
    }
]);